import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';

import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { DirectivesModule } from '@app/shared/directives/directives.module';
import { Utils } from '@src/utils/util';
import { LogComponent } from './log-viewer.component';
import { LogFilterComponent } from './log-viewer-filter/log-viewer-filter.component';
import { LogDataComponent } from './log-viewer-data/log-viewer-data.component'; 
import {HttpClientModule} from '@angular/common/http';

@NgModule({
    imports: [SharedModule, MatTableModule, MatSortModule, MatDatepickerModule, MatInputModule, MatNativeDateModule , HttpClientModule ,DirectivesModule],
    declarations: [LogComponent,LogDataComponent,LogFilterComponent],
    entryComponents: [LogComponent],
    exports: [LogComponent],
    providers: [MatDatepickerModule, MatNativeDateModule, Utils]
})
export class LogViewerModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/log-viewer-ang7/log-viewer.component.module.ts